import React, { useState, useEffect, useMemo } from "react";
import TitleSection from "../../components/TitleSection";
import { Card, Spin, message } from "antd";
import { OfficeProperties } from "../../types/office.type";
import { httpRequest } from "../../helpers/api";
import { BaseResponseProps, BaseResponsePaginationProps } from "../../types/config.type";
import { getErrorMessage } from "../../helpers/errorHandler";
import { EEmployeeRole, EmployeeProperties } from "../../types/employee.type";
import DetailOfficeInformation from "./DetailComponents/OfficeInformation";
import useBreadcrumbs from "../../hooks/useBreadcrumbs";
import useAuth from "../../hooks/useAuth";

const SimpleDetailOffice = () => {
	const { setBreadcrumb } = useBreadcrumbs();

	const [office, setOffice] = useState<OfficeProperties>();
	const [employeeData, setEmployeeData] = useState<EmployeeProperties[]>([]);

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [doneSyncPortal, setDoneSyncPortal] = useState<boolean>(false);

	const { officeId, isHQ } = useAuth();

	useEffect(() => {
		if (officeId && !office) {
			(async () => {
				try {
					const officePromise = httpRequest.get<BaseResponseProps<OfficeProperties>>("offices/" + officeId);

					let url = "employees?filterOfficeId=" + officeId + "&filterRole=franchise_owner,business_owner";
					const employeePromise = httpRequest.get<BaseResponsePaginationProps<EmployeeProperties>>(url);

					let result = await Promise.all([officePromise, employeePromise]);

					let bc = [
						{
							label: result[0].data.payload.officeName,
							origin: officeId,
						},
					];
					setBreadcrumb(bc);
					setOffice(result[0].data.payload);

					setEmployeeData(result[1].data.payload.results);
					setIsLoading(false);
				} catch (err) {
					message.error(getErrorMessage(err));
				}
			})();
		}
		// eslint-disable-next-line
	}, [officeId]);

	const syncOfficePortalProfiles = async () => {
		try {
			await httpRequest.post(`${isHQ ? "" : "/office"}/office-portal-profiles/${officeId}/sync`, {
				originUrl: window.location.href,
			});
			setDoneSyncPortal(true);
		} catch (error) {
			console.error(getErrorMessage(error));
		} finally {
		}
	};
	useEffect(() => {
		if (officeId) {
			syncOfficePortalProfiles();
		}
	}, []);

	useEffect(() => {
		// back to top
		document.getElementById("scroll-content")?.scrollTo(0, 0);
	}, []);

	const FOList = useMemo(
		() =>
			employeeData.filter((item) =>
				item.employeeRole?.find((item) => item.role === EEmployeeRole.franchise_owner)
			),
		[employeeData]
	);

	const BOList = useMemo(
		() =>
			employeeData.filter((item) =>
				item.employeeRole?.find((item) => item.role === EEmployeeRole.business_owner)
			),
		[employeeData]
	);

	const stepProps: any = {
		office,
		officeId,
		FOList,
		BOList,
		doneSyncPortal,
		isSimpleDetail: true,
	};

	return (
		<React.Fragment>
			<TitleSection
				icon="back"
				title={"Detail Office"}
			/>
			<Spin spinning={isLoading}>
				<Card
					bordered={false}
					size="small"
				>
					<DetailOfficeInformation {...stepProps} />
				</Card>
			</Spin>
		</React.Fragment>
	);
};
export default SimpleDetailOffice;
